// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3bD56","buttons":"RemoveExpirationActionButtons_buttons__3cKAZ"};